<template>
<b-tab :title="$t('ARRIVALRECORDWIN')" @click="getData()">
    <div class="">
        <div class="row mb-2">
            <div class="col-12">
                <button type="button" class="btn btn-primary button-add pull-right" @click="showModal()">{{$t('NEW')}}</button>
            </div>
        </div>
        <div class="row">
            <div class="card-body table-logoped" v-if="response.root != null">
                <grid
                    :data="response.root"
                    ref="arrivalRecord"
                    v-model="pagination"
                    :showExport="true"
                    :columns="columns"
                    :totalCount="response.totalCount"
                    :stylingFunc="(item) => setStyling(item)"
                    gridId="arrivalRecordGrid">
                        <template v-slot="{item, column}">
                            <template v-if="column.id == 'actions'">
                                <button type="button" class="btn button-edit mr-lg"  @click="showModal(item)">{{$t('EDIT')}}</button>
                                <button type="button" class="btn button-dlt" @click="deleteRow(item.arrivalRecordsId)">{{$t('DELETE')}}</button>
                            </template>
                        </template>
                </grid>
            </div>
        </div>
        <b-modal ref="formmodal" :title="$t('ARRIVALRECORDFORM')" ok-title="submit" hide-footer no-close-on-backdrop size="lg">
        <div class="d-block">
            <arrivalrecordform v-bind:formData="formData" v-bind:formError="formError"></arrivalrecordform>
        </div>
        <div class="text-right">
            <b-btn class="btn button-cancel mr-2" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
            <b-btn class="btn button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
        </div>
        </b-modal>
    </div>
</b-tab>
</template>

<script>
import moment from 'moment';
import Api from '@/api/child/ArrivalRecord';
import ArrivalRecordForm from './ArrivalRecordForm.vue';

export default
{
    name: 'ArrivalRecord',
    props: ['childId'],
    components:
  {
      arrivalrecordform: ArrivalRecordForm,
  },
    data()
    {
        const me = this;
        return {
            columns: [
                {
                    key: 'recordDateTime',
                    name: me.$t('RECORDDATETIME'),
                    handler(item)
                    {
                        return moment.utc(item.recordDateTime).local().format('DD.MM.YYYY HH:mm:ss');
                    },
                },
                {
                    key: 'terapyType',
                    name: me.$t('TERAPYTYPE'),
                },
                {
                    key: 'description',
                    name: me.$t('DESCRIPTION'),
                },
                {
                    key: 'workType',
                    name: me.$t('WORKTYPE'),
                },
                {
                    key: 'attendance',
                    name: me.$t('ATTENDANCE'),
                    handler(item)
                    {
                        return me.$t(item.attendance.toUpperCase());
                    },
                },
                {
                    id: 'actions',
                    name: me.$t('ACTIONS'),
                },
            ],
            response:
      {},
            formError:
      {},
            formData:
      {
          childId: null,
          terapyId: null,
          recordDateTimeOut: moment().format('YYYY-MM-DD HH:mm:ss'),
          description: '',
          workType: '',
          workTypeId: null,
          amount: '',
          isPayed: 'prepared',
      },
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
          initialId: null,
          sort: null,
          readingType: null,
      },
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
  {
      setStyling(item)
      {
          const style = {};
          if (item.isPayed !== 'prepared')
          {
              if (item.isPayed === 'payed')
              {
                  style['background-color'] = '#87ff87';
              }
              else
              {
                  style['background-color'] = '#FF0000';
              }
          }

          return style;
      },
      async getData()
      {
          const me = this;
          try
          {
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              me.response = data;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async deleteRow(id)
      {
          const me = this;
          try
          {
              me.$store.commit('setModalAlert',
                  {
                      text: me.$i18n.t('AREYOUSHURE'),
                      async btnAction()
                      {
                          const data = await Api.deleteRow(
                              {
                                  id,
                              },
                          );
                          me.$notify.notice(data);
                          await me.getData();
                      },
                  });
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      showModal(item)
      {
          const me = this;
          if (typeof item !== 'undefined')
          {
              me.formData = item;
              // me.formData.recordDateTimeOut = moment.utc(item.recordDateTime).local().format('YYYY-MM-DD HH:mm:ss');
          }
          this.$refs.formmodal.show();
      },
      async submitData(formData)
      {
          const me = this;
          try
          {
            const item = { ...formData };
              if (typeof item.arrivalRecordsId !== 'undefined')
              {
                  item.id = item.arrivalRecordsId;
                  delete (item.arrivalRecordsId);
              }

              item.childId = me.childId;

              const data = await Api.submitData(item);
              if (data.error)
              {
                  me.$notify.notice(data);
                  me.formError = data;
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideModal();
                  await me.getData();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      hideModal()
      {
          const me = this;
          this.$refs.formmodal.hide();

          me.formData = {
              childId: null,
              terapyId: null,
              recordDateTimeOut: moment().format('YYYY-MM-DD HH:mm:ss'),
              description: '',
              workType: '',
              amount: '',
              isPayed: 'prepared',
          };

          me.$emit('reloadWallet');
      },
  },
    watch:
  {
      pagination:
    {
        deep: true,
        handler()
        {
            const me = this;

            if (me.searchTimeout !== false)
            {
                clearTimeout(me.searchTimeout);
            }

            me.searchTimeout = setTimeout(() =>
            {
                me.getData();
                me.searchTimeout = false;
            }, 300);
        },
    },
  },
    computed:
  {
      getParams()
      {
          const me = this;
          const data = {
              ...me.pagination,
          };
          data.start = (data.currentPage - 1) * data.limit;
          data.childId = me.childId;
          return data;
      },
  },
};
</script>
